// redux
import store from '../../redux/store';

const dealershipEditorPermission = (
  {is_superuser = false, branch_editor_permission = false} = store.getState()
    .authorization.userData
) => is_superuser || branch_editor_permission;

export default dealershipEditorPermission;
